<template>
	<BrandCardLayout>
		<h2 class="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white">
			{{ pageTitle }}
		</h2>

		<div
			v-if="showSignInLinks"
			class="mt-2 text-sm">
			<router-link
				:to="{name: 'RequestAccount'}"
				class="link">
				Need an account? Request one to get started
			</router-link>
		</div>

		<div>
			<div
				v-if="$route.name === 'SignIn'"
				class="mt-10">
				<SignInForm
					v-if="!passwordExpired"
					@password-expired="showUpdatePassword()" />
				<PasswordExpiredForm 
					v-else />
			</div>
			<div
				v-else-if="$route.name === 'ForgotPassword' || $route.name === 'ResetPasswordRequested'"
				class="mt-10">
				<ForgotPasswordForm />
			</div>
			<div
				v-else-if="$route.name === 'RequestAccount'"
				class="mt-10">
				<RequestAccountForm />
			</div>
		</div>

		<div v-if="showSignInLinks">
			<v-divider-label
				label="Or"
				class-name="my-6" />

			<router-link
				:to="{name: 'PayInvoice'}"
				class="button btn-white w-full flex">
				Pay an Invoice
			</router-link>

			<p class="mt-4 text-sm text-center text-gray-500 dark:text-gray-400">
				No account required
			</p>
		</div>
	</BrandCardLayout>
</template>

<script lang="ts">
	export default { name: 'SignInMain' } // name the component
</script>

<script setup lang="ts">
	// components
	import BrandCardLayout from '@/layouts/BrandCardLayout.vue'
	import SignInForm from './components/SignInForm.vue'
	import ForgotPasswordForm from './components/ForgotPasswordForm.vue'
	import PasswordExpiredForm from './components/PasswordExpiredForm.vue'
	import RequestAccountForm from './components/RequestAccountForm.vue'

	// router
	import {
		useRoute
	} from "vue-router"

	// vue
	import {
		computed,
		ref
	} from "vue"

	const route = useRoute()
	const passwordExpired = ref(false)

	function showUpdatePassword() {
		passwordExpired.value = true
	}

	// the footer links belong to the sign in form only, not to the other forms this page hosts
	const showSignInLinks = computed(() => {
		return !passwordExpired.value
			&& route.name !== 'RequestAccount'
			&& route.name !== 'ForgotPassword'
			&& route.name !== 'ResetPasswordRequested'
	})

	const pageTitle = computed(() => {
		switch(route.name) {
			case "SignIn": 
				if(passwordExpired.value) return "Update Your Password"
				else return "Customer Login"
			case "ForgotPassword": 
				return "Reset Your Password"
			case "RequestAccount": 
				return "Request Account"
			default:
				return "Customer Login"
		}
	})

</script>
